module.exports = __webpack_public_path__ + "static/media/(V)_MG_4897_-_bijuterias.acc2dba6.jpg";